import { render, staticRenderFns } from "./SkuScanReportInfoCard.vue?vue&type=template&id=c3352d9e&"
import script from "./SkuScanReportInfoCard.vue?vue&type=script&lang=ts&"
export * from "./SkuScanReportInfoCard.vue?vue&type=script&lang=ts&"
import style1 from "./SkuScanReportInfoCard.vue?vue&type=style&index=1&id=c3352d9e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports